module.exports = JBrowseExports["tss-react/mui"];